class EbReveal {
  constructor() {
    this.selector = '[data-eb-reveal]';
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (this.motionQuery.matches) {
      this.revealAll();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.reveal(entry.target);
          this.observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    this.scan();
  }

  scan(root = document) {
    root.querySelectorAll(this.selector).forEach((element) => this.observe(element));
  }

  observe(element) {
    if (!element || element.classList.contains('is-revealed')) return;

    if (!this.observer) {
      this.reveal(element);
      return;
    }

    this.observer.observe(element);
  }

  reveal(element) {
    element.classList.add('is-revealed');
  }

  revealAll() {
    document.querySelectorAll(this.selector).forEach((element) => this.reveal(element));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.ebReveal = new EbReveal();
});
